// @flow
import Section from './Section'

export default Section
export { default as SectionBody } from './SectionBody'
export { default as SectionHeading } from './SectionHeading'
